/* Popovers move to document.body on touch layouts. Keep their public facet context. */
document.addEventListener('listbox:change',event=>{
  const popup=event.target.closest?.('[data-ev-sort-section]');if(!popup)return;
  const value=String(event.detail?.value||'');
  if(![...popup.querySelectorAll('[role="option"]')].some(option=>option.getAttribute('value')===value))return;
  const url=new URL(location.href);url.searchParams.set('sort_by',value);url.searchParams.set('section_id',popup.dataset.evSortSection);url.searchParams.delete('page');
  if(location.pathname.endsWith('/search'))url.searchParams.set('type','product');
  popup.dispatchEvent(new CustomEvent('facet:update',{bubbles:true,detail:{url}}));
});
document.addEventListener('click',event=>{
  const control=event.target.closest?.('[data-ev-open-filter]');if(!control)return;
  const drawer=document.getElementById(control.getAttribute('aria-controls'));if(!drawer)return;
  const target=document.getElementById(control.dataset.evOpenFilter);
  if(target&&drawer.contains(target)){
    drawer.querySelectorAll('details.accordion').forEach(details=>details.open=details===target);
    drawer.addEventListener('dialog:after-show',()=>{target.scrollIntoView({block:'start',behavior:'auto'});target.querySelector('summary')?.focus({preventScroll:true});},{once:true});
  }
});
